import usdt from "../../assets/img/payment/usdt.svg";
export var PAYMENT_PROVIDERS = [
    {
        label: "USDT",
        img: usdt
    },
];



// WEBPACK FOOTER //
// ./src/containers/app/payment-providers.jsx